module.exports = __webpack_public_path__ + "static/img/nodata-video.e7055e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nodata-video.png
// module id = 9s4L
// module chunks = 1